import brandService from "../services/brandService"

export const GET_BRAND = "GET_BRAND"
export const GET_BRAND_SUCCESS = "GET_BRAND_SUCCESS"
export const GET_BRAND_ERROR = "GET_BRAND_ERROR"

export const CREATE_BRAND = "CREATE_BRAND"
export const CREATE_BRAND_SUCCESS = "CREATE_BRAND_SUCCESS"
export const CREATE_BRAND_ERROR = "CREATE_BRAND_ERROR"

export const UPDATE_BRAND = "UPDATE_BRAND"
export const UPDATE_BRAND_SUCCESS = "UPDATE_BRAND_SUCCESS"
export const UPDATE_BRAND_ERROR = "UPDATE_BRAND_ERROR"

export const GET_BRAND_DATA_NEW = "GET_BRAND_DATA_NEW"
export const GET_BRAND_DATA_NEW_SUCCESS = "GET_BRAND_DATA_NEW_SUCCESS"
export const GET_BRAND_DATA_NEW_ERROR = "GET_BRAND_DATA_NEW_ERROR"

export function getBrandRecord(query) {
  return async (dispatch) => {
    dispatch(getBrand())
    return await brandService
      .getBrand(query)
      .then((response) => dispatch(getBrandSuccess(response)))
      .catch((error) => dispatch(getBrandError(error)))
  }
}

export function getBrand() {
  return {
    type: GET_BRAND,
  }
}

export function getBrandSuccess(success) {
  return {
    type: GET_BRAND_SUCCESS,
    payload: { success },
  }
}

export function getBrandError(error) {
  return {
    type: GET_BRAND_ERROR,
    payload: { error },
  }
}

export function createBrandRecord(brand) {


  return async (dispatch) => {
    dispatch(createBrand())
    return await brandService
      .createBrand(brand)
      
      .then((response) => dispatch(createBrandSuccess(response)))
      .catch((error) => dispatch(createBrandError(error)))
  }
}

export function createBrand() {
  return {
    type: CREATE_BRAND,
  }
}

export function createBrandSuccess(success) {
  return {
    type: CREATE_BRAND_SUCCESS,
    payload: { success },
  }
}

export function createBrandError(error) {
  return {
    type: CREATE_BRAND_ERROR,
    payload: { error },
  }
}

export function updateBrandRecord(brand) {
  return async (dispatch) => {
    dispatch(updateBrand())
    return await brandService
      .createBrand(brand)

      .then((response) => dispatch(updateBrandSuccess(response)))
      .catch((error) => dispatch(updateBrandError(error)))
  }
}

export function updateBrand() {
  return {
    type: UPDATE_BRAND,
  }
}

export function updateBrandSuccess(success) {
  return {
    type: UPDATE_BRAND_SUCCESS,
    payload: { success },
  }
}

export function updateBrandError(error) {
  return {
    type: UPDATE_BRAND_ERROR,
    payload: { error },
  }
}

export function getBrandDataNewRecord(query) {
  return async (dispatch) => {
    dispatch(getBrandDataNew())
    return await brandService
      .getBrandDataNew(query)
      .then((response) => dispatch(getBrandDataNewSuccess(response.data)))
      .catch((error) => dispatch(getBrandDataNewError(error)))
  }
}

export function getBrandDataNew() {
  return {
    type: GET_BRAND_DATA_NEW,
  }
}

export function getBrandDataNewSuccess(success) {
  return {
    type: GET_BRAND_DATA_NEW_SUCCESS,
    payload: { success },
  }
}

export function getBrandDataNewError(error) {
  return {
    type: GET_BRAND_DATA_NEW_ERROR,
    payload: { error },
  }
}